var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 94.16,
    viewBox: "0 0 195 94.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-119 -212.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delivery-man",
    transform: "translate(121.5 224.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M403.369,228.265H382.021v7.416a3.338,3.338,0,0,0,3.329,3.331h7.679l4.58,2.314,5.76-2.314V228.265Z",
    transform: "translate(-382.021 -193.143)",
    fill: "#e8d1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M400.041,162.742H385.351a3.338,3.338,0,0,0-3.329,3.331v5.511H403.37v-5.511A3.338,3.338,0,0,0,400.041,162.742Z",
    transform: "translate(-382.022 -138.381)",
    fill: "#e8d1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M403.37,206.463H382.022V211.7H403.37Z",
    transform: "translate(-382.022 -174.921)",
    fill: "#e8d1b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M237.718,293.7H227.377v4.757a2.079,2.079,0,0,0,2.072,2.074h33.668c0-2.99,0-4.512-2.288-4.512l-4.556,0c-2.868,0-4.748-.739-5.8-2.314H237.718Z",
    transform: "translate(-216.37 -247.83)",
    fill: "#16232c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M174.61,335.289H145c-1.736,3.024-3.132,6.658-1.928,13.608,2.014-6.855,22.475-4.118,24.576,3.792h22.576c.854-1.934,1.66-3.845,2.365-5.774h-6.365C173.353,342.057,177.493,344.222,174.61,335.289Z",
    transform: "translate(-131.923 -282.589)",
    fill: "#adadad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M251.8,132.918a48.33,48.33,0,0,1-1.712,6.562l-6.508,2.55-7.257-2.55c.254-13.733,5.386-20.319,9.751-22.45a10.6,10.6,0,0,1,3.185-1.649s2.12,3.391,2.23,3.391a18.217,18.217,0,0,1,1.07,7.2Z",
    transform: "translate(-207.289 -98.799)",
    fill: "#dedede",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M208.38,262.108h13.765c3.17.346,7.07,2.76,7.07,10.239v7.839l-3.124,1.861-4.061-1.861v-6.058c0-2.99,0-4.512-2.288-4.512l-4.556,0c-2.868,0-4.748-.739-5.8-2.314A8.495,8.495,0,0,1,208.38,262.108Z",
    transform: "translate(-179.344 -221.427)",
    fill: "#6d8aa2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M319.6,376.333a12.551,12.551,0,0,0-24.576-3.792,12.873,12.873,0,0,0-.552,3.389c-.014.461.3.4.734.4Q307.4,376.333,319.6,376.333Z",
    transform: "translate(-283.875 -306.232)",
    fill: "#d81212",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M332.846,441.231H313.718a9.569,9.569,0,0,0,19.128,0Z",
    transform: "translate(-300.279 -371.13)",
    fill: "#16232c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M33.123,428.81,16.667,432.6a8.443,8.443,0,1,0,16.456-3.787Z",
    transform: "translate(48.015 -360.749)",
    fill: "#16232c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M20.936,375.375A11.486,11.486,0,0,0,10.35,370.45C2.906,372.025.484,376.474,0,382.023a11.47,11.47,0,0,0,.254,2.271c.048.211.187.125.417.072l2.576-.59L19.7,379.988l1.233-.283,1.722-.4A11.4,11.4,0,0,0,20.936,375.375Z",
    transform: "translate(61.435 -311.927)",
    fill: "#adadad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M90,246.761l-6.648-23-2.993-1.339-3.348,1.339c4.4,12.192,3.17,20.7.2,28.825-.71,1.93-1.516,3.84-2.365,5.774h4.782Z",
    transform: "translate(-18.197 -188.258)",
    fill: "#d81212",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M207.939,65.095l-7.8-1.661c-.791.072-3.055,1.973-3.055,3.163l1.66,8.439a7.617,7.617,0,0,0,2.182.322,7.541,7.541,0,0,0,7.012-10.263Z",
    transform: "translate(-156.724 -55.384)",
    fill: "#ffd9c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M203.842,24.134a9.5,9.5,0,1,0-18.993,0,10.162,10.162,0,0,0,4.048,8.52,9.059,9.059,0,0,0,3.233,1.421V25.636c0-1.19.6-1.43,1.4-1.5h10.317Z",
    transform: "translate(-150.11 -14.423)",
    fill: "#d81212",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M188.493,372.171h-7.185V376.7c0,.97.528,1.042,1.3,1.042h10.312C193.131,373.2,190.383,372.171,188.493,372.171Z",
    transform: "translate(-138.622 -313.413)",
    fill: "#6f6571",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M104.989,184.864l-8.974,2.966c-.441.394.057,4.407.355,4.277H106.8v-6.6C106.8,184.2,106.126,184.49,104.989,184.864Z",
    transform: "translate(-38.451 -156.606)",
    fill: "#adadad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M149.449,207.1h4.537c2.437,0,2.508-4.042-.355-4.277l-4.182-.336-1.122,2.376Z",
    transform: "translate(-96.067 -171.599)",
    fill: "#ffd9c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M194.145,168.256l-1.5-1.291c-3.76-3.24-8.513,2.227-3.487,5.491l4.23,2.746,2.13,1.382h6.739v-4.613l-4.187-.341Z",
    transform: "translate(-148.874 -141.082)",
    fill: "#d9d9d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M238.536,219.771Z",
    transform: "translate(-194.022 -185.652)",
    fill: "#cbc7cb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x1: 190,
    transform: "translate(121.5 304.098)",
    fill: "none",
    stroke: "#9a9a9a",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(237.287 209.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7458",
    "data-name": "Path 7458",
    d: "M74.213,34.874c0,27.642-31.607,55.286-31.607,55.286S11,62.516,11,34.874a31.607,31.607,0,1,1,63.213,0Z",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_434",
    "data-name": "Ellipse 434",
    cx: 25.586,
    cy: 25.586,
    r: 25.586,
    transform: "translate(17.02 8.885)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7460",
    "data-name": "Path 7460",
    d: "M55.533,30.206l-17.62-17.62-17.62,17.62,2.128,2.128,3.451-3.451V43.311H33.4V29.765h9.03V43.311h7.525V28.883L53.4,32.334Z",
    transform: "translate(4.694 4.707)",
    fill: "#9a9a9a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus19);
export default __webpack_public_path__ + "static/media/status-19.f54e6c94fa4fbe529e1b1f984c90ceb0.svg";
export { ForwardRef as ReactComponent };